import React from 'react';
var SpreadSheetBody = function (_a) {
    var id = _a.id, data = _a.data, loading = _a.loading, columns = _a.columns;
    var getHeaderWidth = function (columnId, defaultWidth) {
        var headerCell = document.querySelector("#" + id + " .sheet-head [data-column='" + columnId + "']");
        return headerCell ? parseInt(headerCell.style.minWidth) : defaultWidth;
    };
    var renderRow = function (_a) {
        var index = _a.index, style = _a.style;
        var row = data[index];
        return (React.createElement("div", { className: "sheet-row", key: "spread-sheet-" + id + "-" + index, style: style }, columns.filter(function (c) { return typeof c !== 'undefined'; }).map(function (cell, i) {
            if (!cell.invisible) {
                var left = 0;
                var headerWidth = getHeaderWidth(cell.id, cell.width);
                if (cell.fixed) {
                    left = columns.slice(0, i).reduce(function (sum, v) { return sum + v.width; }, 0);
                }
                var value = cell.render ? cell.render(row[cell.id], row, index)
                    : row[cell.id];
                var className = "sheet-cell " + (cell.fixed ? 'fixed-column' : '') + " " +
                    ("" + (cell.ellipsis ? 'ellipsis' : ''));
                return (React.createElement("div", { className: className, "data-column": cell.id, key: "data-table-cell-" + id + "-" + i, style: {
                        left: left + 'px',
                        minWidth: headerWidth,
                        maxWidth: headerWidth,
                        textAlign: cell.align || 'left',
                    } },
                    React.createElement("span", null, value)));
            }
            else {
                return (React.createElement(React.Fragment, null));
            }
        })));
    };
    return (React.createElement("div", { className: "sheet-container" },
        React.createElement("div", { className: "sheet", "aria-label": "Spread Sheet" },
            React.createElement("div", { className: "sheet-body", id: id + "_grid" }, data.map(function (row, index) { return renderRow({ index: index, style: {} }); })))));
};
export default SpreadSheetBody;
